import React from 'react'
import { Provider } from 'react-redux'
import ReactDOM from 'react-dom/client'
import './reset.css'
import App from './App'
// import reportWebVitals from './reportWebVitals'
import store from './store'
import PlatformContextProvider from './Context/PlatformContext'

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <Provider store={store}>
    <PlatformContextProvider>
      <App />
    </PlatformContextProvider>
  </Provider>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals()
